import * as React from 'react';
import { FIELD_TYPE } from 'app/infrastructure/simple-form/field-types';
import { SimpleFormComponentProps, SerializeType } from 'app/infrastructure/simple-form/types';
import { ids } from 'app/area/administration/constants';
import { Person } from 'app/components/access-panel/shared/types';
import { sfNames } from 'app/area/administration/edit/sf-names';
import { AdminPaperTopPanel } from 'app/area/administration/edit/components';
import { Checkbox, InfoText } from 'ui';
import { AdministrationEditTranslation } from 'app/area/administration/edit/constants';
import styles from './details.scss';

export interface DetailsProps {
  data: Person;
  readOnly: boolean;
  translation: AdministrationEditTranslation;
  formComponent: React.ComponentType<SimpleFormComponentProps>;
  markedAsDefaultRole: boolean;
  changeDefaultRoleMark: (mark: boolean) => void;
}

export const Details = (props: DetailsProps) => {
  const { readOnly, data, formComponent, translation, markedAsDefaultRole, changeDefaultRoleMark } = props;
  const SimpleForm = formComponent;

  const checkboxOnChange = (value: number) => changeDefaultRoleMark(!!value);

  return <AdminPaperTopPanel title={translation.edit_details_title}>
    <div className={styles.detailsContainer}>
      <div className="row">
        <div id={ids.roles.name} className="col-md-12">
          <SimpleForm
            name={sfNames.name}
            type={FIELD_TYPE.TEXTAREA}
            label={{ text: translation.edit_role_details_role_name, required: !readOnly }}
            initialValue={data && data.name}
            readOnly={readOnly}
            maxLength={254}
            serialize={{ type: SerializeType.PRIMITIVE_VALUE }} />
        </div>
      </div>
      <div className="row">
        <div id={ids.roles.id} className="col-md-12">
          <SimpleForm
            name={sfNames.personId}
            type={FIELD_TYPE.TEXTAREA}
            label={{ text: translation.edit_role_details_role_id, required: !readOnly }}
            initialValue={data && data.personId}
            readOnly={readOnly}
            maxLength={80}
            serialize={{ type: SerializeType.PRIMITIVE_VALUE }} />
        </div>
      </div>
      <div className={styles.checkboxContainer}>

        <Checkbox
          className={undefined}
          componentId={'default-role-checkbox'}
          onChange={checkboxOnChange}
          textCheckedValue={translation.set_as_default_role}
          textUncheckedValue={translation.set_as_default_role}
          label={{ visible: true, text: translation.use_as_default_role }}
          value={markedAsDefaultRole ? 1 : 0}
          readOnly={readOnly}
        />
        {!readOnly && <div>
          <InfoText
            visible={true}
            text={translation.default_role_tooltip}
          />
        </div>
        }
      </div>

    </div>
  </AdminPaperTopPanel>;
};
